/*
 * mm-lazy-video.js  (SPEED-OPT, Batch 2 + 3)
 * Decorative videos are emitted WITHOUT the `autoplay` attribute, with preload="none"
 * and a `.mm-lazy-video` marker. Autoplay forces the browser to download the whole file
 * even off-screen; on Slow 4G that starved the LCP hero of bandwidth. This plays each
 * clip only when it scrolls near the viewport (and pauses it when it leaves), so the
 * bytes are fetched on demand. Videos hidden via display:none (the responsive
 * desktop/mobile duplicates) never intersect, so they never download.
 *
 * The marker may sit on the <video> itself (custom homepage sections) OR on a wrapper
 * element (Dawn's media_tag output on the featured product), so we resolve the actual
 * <video> from whichever element carries the class.
 *
 * Carousel JS is untouched — this only observes/plays the <video> elements themselves.
 */
(function () {
  function videoOf(el) {
    return el.tagName === 'VIDEO' ? el : el.querySelector('video');
  }

  function tryPlay(el) {
    var v = videoOf(el);
    if (!v) return;
    v.muted = true;                                  // required for play() w/o a gesture
    if (v.preload === 'none') v.preload = 'auto';    // allow fetch now that it's wanted
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {/* blocked — ignore */});
  }

  function init() {
    var nodes = document.querySelectorAll('.mm-lazy-video');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) tryPlay(nodes[i]);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          tryPlay(entry.target);
        } else {
          var v = videoOf(entry.target);
          if (v && !v.paused) v.pause();
        }
      });
    }, { rootMargin: '200px 0px' }); // start fetching just before it's on screen

    nodes.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
